import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { articleId: Number };

  showArticle(event) {
    event.preventDefault();
    if (window.Intercom) {
      window.Intercom("showArticle", this.articleIdValue);
    }
  }
}
